import COUNTRIES from '../constants/countries';

export function getCountryName(countryCode) {
  const country = COUNTRIES.find(c => c.countryCode === countryCode);
  if (country && country.name) {
    return country.name;
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/utils/countries.js